import Model from '@/models/BaseModel'
import Module from './Module'
import PlanPackage from './PlanPackage'
import i18n from '@/plugins/i18n'

export default class PlanPackageModule extends Model {
    constructor(data = null) {
        super(data)
    }

    resourceName() {
        if (!this.plan_package_id && this.planPackage && this.planPackage.id) {
            this.plan_package_id = this.planPackage.id
        }
        return `plan-packages/${this.plan_package_id}/modules`
    }

    fields() {
        return [
            'id',
            'plan_package_id',
            'module_id',
            'external_id',
            'price',
            'price_type',
            'order',
            'amount',
            'max_amount',
            'add_on',
            'checked',
            'locked',
            'add_amount',
            'combo',
            'courtesy',
            'dependency',
            'created_at',
            'updated_at',
            'deleted_at',
        ]
    }

    dates() {
        return {
            created_at: 'YYYY-MM-DD',
            updated_at: 'YYYY-MM-DD',
            deleted_at: 'YYYY-MM-DD',
        }
    }

    relationships() {
        return {
            planPackage: new PlanPackage(),
            module: new Module(),
        }
    }

    get formattedPrice() {
        return i18n.n(this.price, 'currency')
    }

    get isDeleted() {
        return !this.deleted_at || !this.deleted_at.isValid()
    }

    get isChannel() {
        return this.planPackage && this.planPackage.channel
    }

    restore() {
        return this.makePersistRequest({
            url: `${this.getSelfUrl()}/restore`,
            method: 'POST',
            data: this.data(),
        })
    }
}
